import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  mainWrap: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    background: theme.palette.type === 'dark' ? theme.palette.background.dafault : theme.palette.background.paper,
  },
  containerWrap: {
    marginTop: theme.spacing(8),
    '& > section': {
      position: 'relative'
    }
  },
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
      paddingTop: 28
    },
  },
  articleCategory: {
    fontSize: '16px',
    lineHeight: '30px',
    color: theme.palette.primary.mfs,
    fontWeight: 600
  },
  articleDetail: {},
  bannerContainer: {
    width: '100%',
    borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '0px'
    }
  },
  imageStyle: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  contentContainer: {
    marginTop: '32px',
  },
  gridStyle: {
    [theme.breakpoints.up('md')]: {
      paddingRight: '40px',
      height: '100%'
    }
  },
  containerTitleHeader: {
    display: 'flex',
    width: '100%',
    marginBottom: '60px !important',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(8),
    }
  },
  titleHeader: {
    fontWeight: '600',
    fontSize: '30px'
  },
}));

export default useStyles;
